import React from 'react';
import { AddNewButton } from '@Components/controls/Button/Button';
import { PlusIcon, Text } from '@Components/Card/cards/ContactDisplayDetails/ContactDisplayDetails.styled';

export interface IAddCTA {
	label: string;
	onClick: (e?: any) => void;
	uniqueId: string;
}

const AddCTA = ({ label, onClick, uniqueId }: IAddCTA): JSX.Element => (
	<AddNewButton onClick={onClick} uniqueId={uniqueId}>
		<>
			<PlusIcon>+</PlusIcon>
			<Text>{label}</Text>
		</>
	</AddNewButton>
);

export default AddCTA;
